import React, { useEffect, useState } from "react";
import styles from "../topic.module.css";

import { api } from "../../api/api";
import { useModuleContext } from "../ModuleContext";

export default function GroupPanel() {
  const { language, activeOverlays, toggleOverlay } = useModuleContext();

  // groups (target audiences), configured in the DB (groups/groups_i18n)
  const [groups, setGroups] = useState([]);

  useEffect(() => {
    let cancelled = false;

    api
      .groups(language)
      .then((data) => !cancelled && setGroups(data))
      .catch((err) => console.error("Groups load failed:", err));

    return () => {
      cancelled = true;
    };
  }, [language]);

  return (
    <div className={styles["poi-page"]}>
      <div className={styles.categories}>
        {groups.map((group) => (
          <button
            key={group.key}
            className={
              activeOverlays[group.key]
                ? `${styles.categoryBtn} ${styles.categoryBtnActive}`
                : styles.categoryBtn
            }
            onClick={() => toggleOverlay(group.key)}
          >
            {group.name}
          </button>
        ))}
      </div>
    </div>
  );
}
